import type { MagazineTagForDesignMagazineEditQuery } from "@/lib/gql/__generated__/graphql";

import { useViewData } from "../view-data";
import { useViewModel } from "../view-model";
import { useHandleFinish } from "./use-handle-finish";

type onFinishCallbackProps = {
	tagList: Array<string>;
	regionTag?: string;
	prefectureTag?: string;
	cityTag?: string;
};
type Props = {
	tagList?: Array<string>;
	regionTag?: string;
	prefectureTag?: string;
	cityTag?: string;
	//
	onOpenChange: (open: boolean) => void;
	//
	onFinishCallback: (props: onFinishCallbackProps) => void;

	magazineTagQueryData: MagazineTagForDesignMagazineEditQuery;
};

export const useInitialized = ({
	tagList,
	regionTag,
	prefectureTag,
	cityTag,
	//
	onOpenChange,
	//
	onFinishCallback,

	magazineTagQueryData,
}: Props) => {
	const {
		viewModel,
		// タグ選択時の処理
		onSetSelectedTag,
		// タグ削除時の処理
		onRemoveSelectedTag,
		// タグの一括削除時の処理
		onRemoveAllSelectedTag,
		// 都道府県タグ選択時の処理
		onSetSelectedRegionWithPrefectureTag,
		// 都市タグ選択時の処理
		onSetSelectedCityTag,
		// 地名タグの一括削除時の処理
		onRemoveLocationTag,
	} = useViewModel({
		queryData: magazineTagQueryData,
		tagList,
		regionTag,
		prefectureTag,
		cityTag,
	});

	const { viewData } = useViewData({ queryData: magazineTagQueryData, viewModel });

	const { onFinish } = useHandleFinish({ viewModel, onOpenChange, onFinishCallback });

	return {
		//
		// readonly
		viewData,
		//
		// changeable
		viewModel,
		// タグ選択時の処理
		onSetSelectedTag,
		// タグ削除時の処理
		onRemoveSelectedTag,
		// タグの一括削除時の処理
		onRemoveAllSelectedTag,
		// 都道府県タグ選択時の処理
		onSetSelectedRegionWithPrefectureTag,
		// 都市タグ選択時の処理
		onSetSelectedCityTag,
		// 地名タグの一括削除時の処理
		onRemoveLocationTag,
		//
		// 完了時の処理
		onFinish,
	};
};
